import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { JGRNService } from "../../../services/index";
declare var google;

@Component({
  selector: "bit-current-stock",
  templateUrl: "bitCurrentStock.html",
})
export class bitCurrentStock implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  selected = [];
  isLoading: boolean = false;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  saveEvent: any;

  fabStyleList = ["CHECKS", "PLAIN", "PRINT", "PANEL", "STRIPES"];

  filter = {
    groupby: "to_make",
    width: "",
    fab_style: "",
    size: "",
    to_make: "",
    barcode: "",
  };
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderBy: "ref_no",
    orderDir: "desc",
  };
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("separateBitTemplate") separateBitTemplate: TemplateRef<any>;
  @ViewChild("typeAuto") typeAuto;
  @ViewChild("barcodeAuto") barcodeAuto;
  @ViewChild("designListAuto") designListAuto;

  sel_bits: number = 0;
  tot_mtrs: number = 0;
  splitData = {
    no_of_bits: 0,
  };
  totalMtrs: number = 0;
  splitArray: any;
  data: any;
  splitRowDetails = [];
  splitLength: number = 0;
  columns = [];
  toggleCol = [];
  barcodeDesignList = [];
  barcodeList = [];
  designList = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  user: any;
  total_mtrs: number = 0;
  total_amt: number = 0;
  total_qty: number = 0;
  total_bits: number = 0;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private jgrnService: JGRNService,
    public toasterService: ToasterService
  ) {
    this.data = {
      jgrnList: [],
    };
  }

  ngOnInit(): void {
    this.getColumns();
    // this.getBarcodeDesign();
    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    if (this.filter.groupby == "style") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Width",
          prop: "bitwidth",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Style",
          prop: "fab_style",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "Size",
          prop: "size",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Bit Qty",
          prop: "total_bits",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Mtrs",
          prop: "mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    } else if (this.filter.groupby == "width") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Width",
          prop: "bitwidth",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        // {
        //   name: "Style",
        //   prop: "fab_style",
        //   cellClass: "text-center",
        //   headerClass: "text-center",
        //   minWidth: 90,
        //   maxWidth: 90,
        //   width: 90,
        // },
        {
          name: "Size",
          prop: "size",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "To Make",
          prop: "type",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 140,
          maxWidth: 140,
          width: 140,
        },
        {
          name: "Bit Qty",
          prop: "total_bits",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Mtrs",
          prop: "mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    } else if (this.filter.groupby == "to_make") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "To Make",
          prop: "type",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 140,
          maxWidth: 140,
          width: 140,
        },
        {
          name: "Bit Qty",
          prop: "total_bits",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Mtrs",
          prop: "mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    } else {
      this.columns = [
        // {
        //   prop: "selected",
        //   name: "",
        //   sortable: false,
        //   canAutoResize: false,
        //   draggable: false,
        //   resizable: false,
        //   headerCheckboxable: true,
        //   checkboxable: true,
        //   width: 30,
        // },
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Barcode",
          prop: "barcode",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Party design",
          prop: "party_design",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 85,
          maxWidth: 85,
          width: 85,
        },
        {
          name: "Fab design",
          prop: "fab_design",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "Fab Style",
          prop: "fab_style",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },

        {
          name: "Width",
          prop: "bitwidth",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "color",
          prop: "color",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Mtrs",
          prop: "totalmtrs",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Avl Mtrs",
          prop: "avl_mtrs",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Rate / Mtr",
          prop: "tot_rate",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
        {
          name: "Tot Amt",
          prop: "tot_amt",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 110,
          maxWidth: 110,
          width: 110,
        },
      ];
      let splitBit = {
        name: "Split Bit",
        prop: "sno",
        minWidth: 100,
        maxWidth: 120,
        width: 110,
        sortable: false,
        cellTemplate: this.separateBitTemplate,
      };
      let sizeCheck = this.filter.size.split("");
      if (sizeCheck[0] == ">") {
        this.columns.splice(12, 0, splitBit);
      }
    }

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  // getBarcodeDesign(){
  //   this.jgrnService.barcodeDesignlist({}).then((res: any) => {
  //     this.barcodeDesignList = res.data;

  //     this.barcodeList = this.barcodeDesignList.map(el => el.barcode);
  //     this.designList = this.barcodeDesignList.map(el => el.fab_design);
  //     for (let i = 0; i < this.barcodeList.length; i++) {
  //       this.barcodeList[i] = this.barcodeList[i]
  //         .toString()
  //         .padStart(6, "0");
  //     }
  //   });
  // }
  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;

    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getOrderList();
  }

  clearFilter(): void {
    this.applyFilter();
  }

  applyFilter(): void {
    this.getColumns();
  }
  applyFilterView(row) {
    if (this.filter.groupby == "style") {
      this.filter.groupby = "BIT";
      this.filter.width = row.width;
      this.filter.to_make = row.type;
      this.filter.fab_style = row.fab_style;
      this.filter.size = row.size;
    }
    if (this.filter.groupby == "width") {
      this.filter.groupby = "style";
      this.filter.width = row.width;
      this.filter.to_make = row.type;
      this.filter.size = row.size;
    }
    if (this.filter.groupby == "to_make") {
      this.filter.groupby = "width";
      this.filter.to_make = row.type;
    }
    this.getColumns();
  }
  gobacktoffGroup() {
    if (this.filter.groupby == "width") {
      this.filter.groupby = "to_make";
      this.filter.to_make = "";
    }

    if (this.filter.groupby == "style") {
      this.filter.groupby = "width";
      this.filter.width = "";
      this.filter.fab_style = "";
      this.filter.size = "";
    }

    if (this.filter.groupby == "BIT") {
      this.filter.groupby = "style";
      this.filter.fab_style = "";
      this.filter.barcode = "";
    }

    this.getColumns();
  }
  onEnterNoOfBits(bits) {
    this.splitArray = Array(bits).fill(bits);
  }
  splitRow(row) {
    this.splitData = {
      no_of_bits: 0,
    };
    this.totalMtrs = 0;
    this.splitArray = [];
    this.splitRowDetails = [];
    this.splitLength = 0;

    this.splitRowDetails = row;
    this.splitLength = Object.keys(this.splitRowDetails).length;
  }
  getOrderList(): void {
    let params = {
      start: `${this.page.offset * this.page.limit}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
      //order_from_date:this.filter.order_from_date
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.jgrnService
      .getbitStockList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        that.total_mtrs = 0;
        that.total_bits = 0;
        that.total_amt = 0;

        if (
          that.filter.groupby == "width" ||
          that.filter.groupby == "style" ||
          that.filter.groupby == "to_make"
        ) {
          that.orderList.forEach((el) => {
            that.total_mtrs += el.mtrs;
            that.total_bits += el.total_bits;
          });
        } else {
          that.orderList.forEach((el) => {
            that.total_mtrs += el.avl_mtrs;
            that.total_amt += el.tot_amt;
          });
          that.total_bits = that.orderList.length;
          that.total_amt =
            Math.round((that.total_amt + Number.EPSILON) * 100) / 100;
        }
        that.total_mtrs =
          Math.round((that.total_mtrs + Number.EPSILON) * 100) / 100;
        that.total_bits =
          Math.round((that.total_bits + Number.EPSILON) * 100) / 100;
      });
  }
  calcBit(bit) {
    this.totalMtrs += Number(bit);
  }
  onEnterSplit() {
    let that = this;

    if (Number(that.totalMtrs.toFixed(2)) != Number(that.splitRowDetails["avl_mtrs"])) {
      swal("Please tally splitted bits with original bit");
      return;
    }

    let params = {
      splitData: JSON.stringify(that.splitData),
      splitRow: JSON.stringify(that.splitRowDetails),
    };
    that.isLoadMask = that.jgrnService.splitBit(params).then((res: any) => {
      if (res.success) {
        that.toasterService.pop({
          bodyOutputType: 1,
          type: "success",
          title: "SUCCESS",
          body: res.message,
        });
        swal({
          title: "Click YES for Sticker Print?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes!",
          cancelButtonText: "No",
        })
          .then(() => {
            that.loadeditJGRNPrintList(res.split_id);
          })
          .catch(() => {});
      } else {
        swal("SOMETHING WENT WRONG");
      }
    });
  }
  loadeditJGRNPrintList(split_id) {
    let params = {
      jgrn_id: split_id,
      stock_type: "SPLIT BIT",
    };
    let that = this;
    that.jgrnService
      .getEditJGRNList(params)
      .then((res: any) => {
        that.data.jgrnList = res.data;
        var row = res.data[0];
        // that.calcTotal();
        // that.calcQty();
        if (row.jgrnType == "BIT") {
          swal({
            title:
              "Please ensure that Small Sticker roll (Bit Roll) was inserted...",
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "Ok",
          })
            .then(() => {
              that.clickPrint(row, res.data);
            })
            .catch(() => {});
        } else {
          swal({
            title:
              "Please ensure that large Sticker roll (Bulk Roll) was inserted...",
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "Ok",
          })
            .then(() => {
              that.clickPrint(row, res.data);
            })
            .catch(() => {});
        }
      })
      .catch(() => {});
  }
  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.jgrnService
      .jgrnprint(params)
      .then(function (res: any) {
        // jQuery.noConflict();
        $("#barcodeShow").modal("show");
        that.getColumns();
      })
      .catch(() => {});
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    console.log(this.selected);

    this.tot_mtrs = 0;
    this.sel_bits = 0;

    this.selected.forEach((el) => {
      this.tot_mtrs += el.avl_mtrs;
    });
    this.tot_mtrs = Math.round((this.tot_mtrs + Number.EPSILON) * 100) / 100;
    this.sel_bits = this.selected.length;
  }
  getId(row) {
    return row.jgrn_det_id;
  }
  getIdFunction() {
    return this.getId.bind(this);
  }
  // onSubmitfabStore() {
  //   if (this.selected.length > 0) {
  //     this.selectedWoNo = [];
  //     this.selectedWoNo = this.selected.map((el) => el.wo_id);
  //     let that = this;
  //     swal({
  //       title: "Are you sure to Move this Work order(s) to Cutting Plan?",
  //       type: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: "Yes, Move it!",
  //       cancelButtonText: "No, want to change",
  //     }).then(function () {
  //       let params = {
  //         selectedWoNo: JSON.stringify(that.selectedWoNo),
  //       };
  //       that.isLoading = true;
  //       that.loadingIndicator = true;
  //       that.isLoadMask = that.jgrnService
  //         .moveToCuttingPlan(params)
  //         .then(function (res: any) {
  //           that.loadingIndicator = false;
  //           that.isLoading = false;

  //           if (res.success) {
  //             that.selected = [];
  //             that.selectedWoNo = [];
  //             swal("Moved to Cutting Plan on " + "C.P No " + res.data);
  //             that.getOrderList();
  //             let tabObj = {
  //               action: "CloseTab",
  //               params: {},
  //             };
  //             that.tabUpdateEvent.emit(tabObj);
  //           }
  //         });
  //     });
  //   } else {
  //     swal("Select Atleast One WO.NO");
  //   }
  // }
  onSubmitWo(mode: string, row: any) {
    if (this.selected.length > 0) {
      let listUpdateEvent = new EventEmitter();
      listUpdateEvent.subscribe(() => {
        this.selected = [];
        this.getOrderList();
        this.getIdFunction();
      });

      row = this.selected;
      row.tabevent = listUpdateEvent;
      let tabObj = {};
      if (mode == "WorkOrderDc") {
        tabObj = {
          action: "NewTab",
          params: {
            tabName: "ADD CLOTH DC",
            title: "ADD CLOTH DC",
            tabParent: "CLOTH",
            mode: mode,
            data: row,
            name: "AddEditDC",
          },
        };
      }
      this.tabUpdateEvent.emit(tabObj);
    } else {
      swal("Select Atleast One WO.NO");
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/bitStockReport/bitCurrentStock.ts